<template>
  <div
    class="staff__contact flex items-center"
    :class="{'bg-primary-gradient text-white': isActive}"
    id="category-item"
  >
    <div class="w-full">
      <vs-row class="container">
        <vs-col class="w-3/4 p-3 pr-0 flex align-center">
          <div class="flex align-center w-full">
            <feather-icon icon="MoveIcon" svgClasses="w-5 stroke-current mr-4 cursor-pointer icon-group move-btn" v-if="serviceData.id != 999999" />
            <feather-icon icon="MoveIcon" svgClasses="w-5 stroke-current mr-4 cursor-pointer icon-group move-btn" style="opacity: 0; pointer-events: none" v-else />
            <div class="mr-3 category-color" :style="{background: getCategoryColor(serviceData)}"></div>
            <h5 class="font-semibold w-11/12 category-name" :class="{'text-white': isActive}">{{serviceData.name}}</h5>
          </div>
        </vs-col>
        <vs-col class="w-1/4 flex flex-col align-center p-6 py-5" v-if="serviceData.id != 999999">
          <div class="flex align-center" v-if="serviceData.type == 'service' || serviceData.type == undefined">
            <img src="../../assets/images/pen-icon-white.png" class="ml-4 cursor-pointer icon-group pen-icon" v-if="isActive" @click="editCate" />
            <img src="../../assets/images/pen-icon-black.png" class="ml-4 cursor-pointer icon-group pen-icon" v-else @click="editCate" />
            <img src="../../assets/images/trash-icon-white.png" class="ml-4 cursor-pointer icon-group trash-icon" v-if="isActive" @click="popupActive = true" />
            <img src="../../assets/images/trash-icon-black.png" class="ml-4 cursor-pointer icon-group trash-icon" v-else @click="popupActive = true" />
            <vs-popup class="holamundo delete-category-popup" title="Delete Item" :active.sync="popupActive">
              <div class="text-center">
                <h3>Do you want to delete item?</h3>
                <div class="flex flex-wrap items-center align-center p-6 justify-center">
                  <vs-button class="mr-6 align-center delete-responsive" @click="deleteData">Delete</vs-button>
                  <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
                </div>
              </div>
            </vs-popup>
          </div>
          <div class="flex align-center" v-else>
            <img src="../../assets/images/pen-icon-white.png" class="ml-4 cursor-pointer icon-group pen-icon" v-if="isActive" @click="editCate" />
            <img src="../../assets/images/pen-icon-black.png" class="ml-4 cursor-pointer icon-group pen-icon" v-else @click="editCate" />
            <img src="../../assets/images/trash-icon-white.png" class="ml-4 cursor-pointer icon-group trash-icon" style="opacity: 0;" />
            <vs-popup class="holamundo delete-category-popup" title="Delete Item" :active.sync="popupActive">
              <div class="text-center">
                <h3>Do you want to delete item?</h3>
                <div class="flex flex-wrap items-center align-center p-6 justify-center">
                  <vs-button class="mr-6 align-center delete-responsive" @click="deleteData">Delete</vs-button>
                  <vs-button type="border" color="danger" class="cancel-responsive" @click.stop="closePopup">Cancel</vs-button>
                </div>
              </div>
            </vs-popup>
          </div>
        </vs-col>
        <vs-col class="w-1/4 flex flex-col align-center p-6 py-5" v-else>
          <img src="../../assets/images/trash-icon-white.png" class="ml-4 cursor-pointer icon-group trash-icon" style="opacity: 0;" />
        </vs-col>
      </vs-row>
    </div>
  </div>
</template>

<script>
export default {
  name: "category-item",
  props: {
    isActive: { type: Boolean },
    serviceData: { type: Object, required: true },
    currentPage: { type: Number ,required: true },
    // typeCate: {
    //   type: String,
    //   required: true
    // }
  },
  data() {
    return {
      popupActive: false,
      // currentPage: 1,
      itemsPerPage: 10,
      themeColors: this.$store.getters["staffList/themeColorsCate"],
    };
  },
  computed:{
     id:{
        get() {return this.serviceData.id},
        set(){}
      }
  },
  methods: {
    getCategoryColor(cate) {
      if(cate.color_detail) {
        return cate.color_detail.color_code;
      }
      return this.themeColors[1];
    },
    deleteData(){
      const obj ={
        id: this.id,
        page: this.currentPage,
        "per-page": this.itemsPerPage
      }
      this.popupActive = false;
      this.$emit("DeleteCategory" , obj)
    },
    closePopup(){
      this.popupActive = false;
    },
    editCate() {
      this.$emit("EditCate", this.serviceData);
    },
  },
  created() {}
};
</script>
